module.exports = __webpack_public_path__ + "15_hair_black.bf11efa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/15_hair_black.png
// module id = Mb+S
// module chunks = 0